import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/constants";

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-7xl px-4 pb-16 md:px-6 md:pb-20">
      <div className="relative overflow-hidden rounded-lg bg-primary-600 px-6 py-14 text-center md:px-12 md:py-16">
        <div className="absolute -left-10 -top-10 h-40 w-40 rounded-full bg-white/10" />
        <div className="absolute -bottom-12 -right-12 h-56 w-56 rounded-full bg-white/10" />

        <div className="relative z-10 mx-auto max-w-2xl">
          <h2 className="font-heading text-2xl font-semibold text-white md:text-4xl">
            {t("cta.title")}
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-white/85 md:text-base">
            {t("cta.subtitle")}
          </p>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-7 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-white"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-shopping-bag-line text-base" />
            </span>
            {t("cta.button")}
          </a>
        </div>
      </div>
    </section>
  );
}